export class PushCartRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.setTimeout(() => this.render(), 500)
  }

  disconnectedCallback () {
    super.disconnectedCallback()
  }

  render () {
    if (!this.dataset.productId) {
      this.expanded = false
      return
    }

    this.loading = true

    fetch(this.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text

        const recommendations = html.querySelector('push-cart-recommendations')
        const hasItems =
          recommendations && recommendations.innerHTML.trim().length

        if (hasItems) {
          document
            .querySelectorAll('.psh-Recommendations')
            .forEach((container) => {
              container.innerHTML = recommendations.innerHTML
            })
        }

        this.expanded = !!hasItems
      })
      .catch((e) => {
        console.error(e)
      })
      .finally(() => {
        this.loading = false
      })
  }

  get expanded () {
    return this._expanded
  }

  set expanded (expanded) {
    this._expanded = expanded

    document
      .querySelector('site-drawer[key="cart"] .drw-Drawer_Aside')
      ?.setAttribute('aria-expanded', expanded)

    document
      .querySelector('.psh-Cart_Recommendations')
      ?.setAttribute('loaded', expanded)
  }

  get loading () {
    return this._loading
  }

  set loading (loading) {
    this._loading = loading

    document
      .querySelector('site-drawer[key="cart"] .drw-Drawer_Aside')
      ?.classList.toggle('drw-Drawer_Aside-loading', loading)
  }

  get url () {
    return this.dataset.url
  }
}

if (!customElements.get('push-cart-recommendations')) {
  customElements.define('push-cart-recommendations', PushCartRecommendations)
}
